import { ChangeEvent, useContext } from 'react';
import isEqual from 'lodash/isEqual';
import { useTranslation } from 'react-i18next';
import {
  Flex,
  Form,
  FormContext,
  Input,
  InputPhone,
  InputPhoneValue,
  Text,
} from 'dash-ui';

import { FormFields } from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/constants/constants';
import useValidation from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/hooks/useValidation';

const ContanctInfo = () => {
  const { t } = useTranslation('forms');
  const { stateHandlers, formState, formErrors } = useContext(FormContext);
  const valid = useValidation();

  const onPhoneChanged = ({ dialCode, number }: InputPhoneValue) => {
    if (!isEqual(formState.contactPhone, { dialCode, number }))
      stateHandlers[FormFields.ContactPhone]({
        dialCode,
        number,
      });
  };

  const onChange =
    (fieldName: FormFields) => (e: ChangeEvent<HTMLInputElement>) => {
      stateHandlers[fieldName](e.target.value);
      valid(fieldName, e.target.value);
    };

  return (
    <>
      <Text semibold>{t('labels.contactInfo')}</Text>
      <Flex w="100%" flexDirection="row" mt={2}>
        <Flex w="100%" flexDirection="column" mr={2} flex={1}>
          <Form.Label>{t('forms:labels.phoneNumber')}</Form.Label>
          <InputPhone
            number={formState.contactPhone?.number}
            dialCode={formState.contactPhone?.dialCode}
            placeholder={t('forms:placeholders.phoneNumber') || ''}
            onChangePhoneValue={onPhoneChanged}
            $errorType={formErrors[FormFields.ContactPhone]?.type}
          />
          <Form.Feedback $errorType={formErrors[FormFields.ContactPhone]?.type}>
            {formErrors[FormFields.ContactPhone]?.message}
          </Form.Feedback>
        </Flex>
        <Flex w="100%" flexDirection="column" mr={2} flex={1}>
          <Form.Label>{t('forms:labels.email')}</Form.Label>
          <Input
            w="100%"
            type="email"
            value={formState.contactEmail || ''}
            placeholder={t('forms:placeholders.email') || ''}
            onChange={onChange(FormFields.ContactEmail)}
            $errorType={formErrors[FormFields.ContactEmail]?.type}
          />
          <Form.Feedback $errorType={formErrors[FormFields.ContactEmail]?.type}>
            {formErrors[FormFields.ContactEmail]?.message}
          </Form.Feedback>
        </Flex>
        <Flex w="100%" flexDirection="column" flex={1}>
          <Form.Label>{t('forms:labels.websiteOfProperty')}</Form.Label>
          <Input
            w="100%"
            value={formState.website || ''}
            placeholder={t('forms:placeholders.websiteOfProperty') || ''}
            onChange={onChange(FormFields.Website)}
            $errorType={formErrors[FormFields.Website]?.type}
          />
          <Form.Feedback $errorType={formErrors[FormFields.Website]?.type}>
            {formErrors[FormFields.Website]?.message}
          </Form.Feedback>
        </Flex>
      </Flex>
    </>
  );
};

export default ContanctInfo;
